import * as Yup from "yup";
export const initialValues = (data = {}) => {
    let start = data?.start_time;
    if (start && start.length > 5) start = start.substring(0, 5);
    let end = data?.end_time;
    if (end && end.length > 5) end = end.substring(0, 5);

    return {
        en: {
            description:
                data?.localized_data?.en?.description ||
                data?.en?.description ||
                "",
        },
        ar: {
            description:
                data?.localized_data?.ar?.description ||
                data?.ar?.description ||
                "",
        },
        start_time: start || "",
        end_time: end || "",
    };
};
export const structure = (_, __, t) => [
    {
        head: "",
        width: "100%",
        list: [
            {
                name: `en.description`,
                kind: "input",
                type: "text",
                label: `${t("lookups_delivery_times.delivery_times_en")}*`,
                width: "47%",
            },
            {
                name: `ar.description`,
                kind: "input",
                type: "text",
                label: t("lookups_delivery_times.delivery_times_ar"),
                width: "47%",
            },
            {
                name: "start_time",
                kind: "input",
                type: "time",
                label: `${t("lookups_delivery_times.start_time")}*`,
                width: "47%",
                InputLabelProps: {
                    shrink: true,
                },
            },
            {
                name: "end_time",
                kind: "input",
                type: "time",
                label: `${t("lookups_delivery_times.end_time")}*`,
                width: "47%",
                InputLabelProps: {
                    shrink: true,
                },
            },
        ],
    },
];

export const validationSchema = (t) =>
    Yup.object({
        en: Yup.object().shape({
            description: Yup.string().required('Required'),
        }),
        ar: Yup.object().shape({
            description: Yup.string(),
        }),
        start_time: Yup.string().required('Required'),
        end_time: Yup.string().required('Required'),
    });
